import { NS } from "../common/classes";

export const FLOATING_TEXTAREA = `${NS}-floating-textarea`;
export const FLOATING_TEXTAREA_CONTAINER = `${FLOATING_TEXTAREA}-container`;
export const FLOATING_TEXTAREA_LABEL = `${FLOATING_TEXTAREA}-label`;
export const FLOATING_TEXTAREA_COUNTER = `${FLOATING_TEXTAREA}-counter`;
